import { render, staticRenderFns } from "./AccessDataForm.vue?vue&type=template&id=4a09ea7a&"
import script from "./AccessDataForm.vue?vue&type=script&lang=js&"
export * from "./AccessDataForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports